import { makeStyles, TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { useField, useFormikContext } from "formik";
import React from "react";

const useStyles = makeStyles(theme => ({
  textField: {
    "& > .MuiOutlinedInput-root": {
      backgroundColor: theme.palette.background.paper,
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      "& > .MuiOutlinedInput-input": {
        padding: "14.5px 25px !important"
      }
    }
  }
}));

const AutocompleteField = ({ name, label, variant, className, options, submitOnChange }) => {
  const classes = useStyles();
  const [field] = useField(name);
  const { submitForm } = useFormikContext();
  return (
    <Autocomplete
      className={className}
      getOptionLabel={option => option.label || ""}
      value={options.find(({ value }) => value === field.value)}
      options={options}
      name={name}
      onChange={(_, selectedOption) => {
        field.onChange({ currentTarget: { name, value: selectedOption?.value || "" } });
        if (submitOnChange) {
          submitForm();
        }
      }}
      renderInput={params => (
        <TextField
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...params}
          label={label}
          variant={variant}
          className={classes.textField}
        />
      )}
    />
  );
};

export default AutocompleteField;
